import { toast } from "@inno-ui/toast";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import type { GetSmartSchedulingAvailabilitiesResponse } from "../../api/smart-scheduling/smart-scheduling.types";

import { getSmartSchedulingAvailabilities } from "../../api/smart-scheduling/get-smart-scheduling-availabilities";

export function useGetSmartSchedulingAvailabilities() {
  const { t } = useTranslation();

  const { userToken } = useParams();
  if (!userToken) {
    toast.error({ title: t("User token is required") });
    return;
  }

  return useQuery<GetSmartSchedulingAvailabilitiesResponse>({
    queryKey: ["smart-scheduling-availabilities", userToken],
    queryFn: () => getSmartSchedulingAvailabilities(userToken),
    enabled: !!userToken,
  });
}
